'use strict';

angular.module('ClinicApp').controller('InsurancePlanSelector', function(
  $scope,
  $modalInstance,
  plans,
  title,
  selectedPlan,
  readOnly,
  $timeout,
  OpencareConstants,
) {
  $scope.plans = _.clone(plans);
  $scope.title = title || 'Select plans';
  $scope.selectedPlanId = _.get(selectedPlan, 'id');

  // Providers Opencare manages are listed read-only for practice users.
  $scope.readOnly = !!readOnly;
  $scope.contactEmail = OpencareConstants.managedInsurance.contactEmail;

  if ($scope.selectedPlanId) {
    $timeout(function() {
      // Scroll to the selected item in the list.
      var listEl = angular.element('#js-insurance-plan-selector-modal-list');
      var planEl = listEl.find('[data-id="' + $scope.selectedPlanId + '"]');
      if (listEl.length && planEl.length) {
        listEl.scrollTop(planEl.position().top - listEl.position().top);
      }
    });
  }

  $scope.togglePlanSupport = (plan) => {
    if ($scope.readOnly) {
      return;
    }
    plan.supported = !plan.supported;
  };

  $scope.save = function() {
    $modalInstance.close($scope.plans);
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
